import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AssessmentCard from "../../../../../_components/common/AssessmentCard";
import { Link } from "react-router-dom";
import CompareSvg from "../../../../../images/compare-button.svg";
import { history } from "../../../../../_helpers";
import InstrumentIcon from "../../../../../images/instrument.svg";

import { FormGroup, Label, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";

import axios from "axios";
import addAccessTokenToUrl from "../../../../Utils/Axios/addTokenToUrl";
import './index.css'
import { useMobileStatus } from "../../../../Utils/useMobileStatus";


export default function AssessmentCardList({ reload }) {
  const [assessmentStatus, setAssessmentStatus] = useState(true);
  const [selectedAssessmentIds, setSelectedAssessmentIds] = useState([]);
  const [isToastVisible, setIsToastVisible] = useState(false);

  const participantId = localStorage.getItem("participant_id");
  const [instrumentDropdownOpen, setInstrumentDropdownOpen] = useState(false);
  const [selectedOption2, setSelectedOption2] = useState("LOI Self");



  const toggleInstrumentDropdown = () => setInstrumentDropdownOpen(!instrumentDropdownOpen);

  const handleDropdownChange = (option) => {
   

    setSelectedOption2(option);
    setSelectedAssessmentIds([]);
    setIsTickVisibleArray([]);

    localStorage.removeItem('selectedAssessmentIds');
    
   
   
  
   
   
  };


  useEffect(() => {
    localStorage.removeItem('selectedAssessmentIds');
  }, []);

  


  const isMobile = useMobileStatus();



  const [assessmentsArray, setAssessmentData] = useState([]);
 
  useEffect(() => {
   

    const storedSelectedAssessmentIds = JSON.parse(localStorage.getItem('selectedAssessmentIds')) || [];
  
    getAssessmentList()
      .then((response) => {
  

        const newData = response.data.data.map((item) => ({
          id: item.id,
          created: new Date(item.created).toISOString().split("T")[0],
        }));
      
        setAssessmentStatus(true);
        setAssessmentData(newData);
        setSelectedAssessmentIds(storedSelectedAssessmentIds);
        setIsTickVisibleArray(newData.map((item) => storedSelectedAssessmentIds.includes(item.id)));
      })
      .catch((error) => {
        setAssessmentStatus(false);
        console.error("Error fetching assessment list:", error);
      });
  }, [selectedOption2]); // Add selectedOption2 to the dependency array
  function getAssessmentList() {
    const instrumentId = selectedOption2 === "LOI Self" ? 9 : 2;
    const requestBody = {
      instrument_id: instrumentId,
      user: participantId,
    };
   

  
    return axios.post(
      addAccessTokenToUrl("/assessments/date_range/assessments/list"),
      requestBody
    );
  }

  const [isTickVisibleArray, setIsTickVisibleArray] = useState(
    new Array(assessmentsArray.length).fill(false)
  );

  const handleSingleClick = (index) => {
    if (
      isTickVisibleArray.filter(Boolean).length === 3 &&
      !isTickVisibleArray[index]
    ) {
      if (!isToastVisible) { // Only show toast if none is currently visible
        toast["info"](`You can only select up to 3 cards.`, {
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 2000,
          onClose: () => setIsToastVisible(false), // Reset the flag when toast closes
          onOpen: () => setIsToastVisible(true) // Set the flag when toast opens
        });
      }
      return;
    }

    setIsTickVisibleArray((prevArray) => {
      const newArray = [...prevArray];

      if (newArray[index]) {
        newArray[index] = false;
      } else {
        const selectedCount = newArray.filter(Boolean).length;
        if (selectedCount < 3) {
          newArray[index] = true;
        }
      }

      return newArray;
    });
    setSelectedAssessmentIds((prevIds) => {
      const newIds = prevIds.includes(assessmentsArray[index].id)
        ? prevIds.filter((id) => id !== assessmentsArray[index].id)
        : [...prevIds, assessmentsArray[index].id];

      localStorage.setItem('selectedAssessmentIds', JSON.stringify(newIds));
      return newIds;
    });
  };


  const onBackClick = () => {
    // setIsContinueClicked(false);
    localStorage.removeItem('filterData')
  };
  const isLinkDisabled =
    isTickVisibleArray.filter(Boolean).length < 2 ? true : false;



  const handleCompareClick = () => {
    localStorage.setItem("assessmentIds", selectedAssessmentIds);

    const newFormData = {
    formData: {
      dateRangeValue: { startDate: "13/08/2024", endDate: '13/08/2024' },
      dropdown2: selectedOption2, // Use the value from the dropdown
      orientation: [
        "Relationship",
        "Leadership",
        "Achievement",
        "Nurturing",
        "Learning",
      ],
      relation: selectedOption2 === "LOI 360" ? "360-Degree Feedback" : "",
    }
  };
  localStorage.setItem("filterData", JSON.stringify(newFormData));



    history.push("/new/app/assessment-report");
  };


  return (
    <div>
      <FormGroup style={{ paddingTop: isMobile ? '20px' : '0px',width: isMobile ? '100%' : 'auto' }}>
        <Label for="dropdown2" style={{ color: "grey" }}>
          Select Instrument
          <span style={{ color: "red" }}>*</span>
        </Label>

        <ButtonDropdown
          isOpen={instrumentDropdownOpen}
          toggle={toggleInstrumentDropdown}
          style={{  width: isMobile ? "100%" : "400px", height: "50px", background: "white" }}
        >
          <DropdownToggle
            onClick={toggleInstrumentDropdown}
            className="d-flex justify-content-between align-items-center"
            style={{
              background: "white",
              color: "black",
              paddingLeft: "10px",
              paddingRight: "10px",
              border: "1px solid #dbdbdb",
            }}
          >
            {selectedOption2 ? (
              selectedOption2
            ) : (
              <div>
                <img src={InstrumentIcon} alt="#" /> Select Instrument
              </div>
            )}
            <i className="fa fa-chevron-down" aria-hidden="true" />
          </DropdownToggle>
          <DropdownMenu style={{ width:isMobile ? "100%" : "400px", padding: 0 }}>
            <DropdownItem
              style={{
                width: '100%',
                height: "50px",
                background: "white",
                display: "flex",
                alignItems: "center",
                paddingLeft: "40px",
              }}
              onClick={() => handleDropdownChange("LOI Self")}
            >
              LOI Self
            </DropdownItem>
            <hr />
            <DropdownItem
              style={{
                width: "100%",
                height: "50px",
                background: "white",
                display: "flex",
                alignItems: "center",
                paddingLeft: "40px",
              }}
              onClick={() => handleDropdownChange("LOI 360")}
            >
              LOI 360
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>

      </FormGroup>
      {assessmentStatus ? (
        <div
        key={JSON.stringify(assessmentsArray)}
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "15px",
          }}
        >
          {assessmentsArray.map((assessment, index) => (
            <div key={index} onClick={() => handleSingleClick(index)}>
              <AssessmentCard
                isTickVisible={isTickVisibleArray[index]}
                assessmentName={assessment.created}
                disabled={
                  isTickVisibleArray.filter(Boolean).length === 3 &&
                  !isTickVisibleArray[index]
                }
              />
            </div>
          ))}
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
            fontSize: "24px",
            alignItems: "center",
            height: "300px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          NO ASSESSMENT FOUND
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          padding: "40px 0px",
        }}
      >
        <Link to="/new/app/reports/:id">
          <Button
            style={{
              height: "60px",
              width: "150px",
              backgroundColor: "#ffffff",
              border: "solid 1px #ff6600",
              color: "#ff6600",
            }}
            type="back"
            onClick={onBackClick}
          >
            BACK
          </Button>
        </Link>


        {isLinkDisabled ? (
          <div
            className="disabledButton"
          >
            <img
              src={CompareSvg}
              alt="Compare Icon"
              style={{ marginRight: "10px" }}
            />
            COMPARE ASSESSMENTS
          </div>
        ) : (

          <Button
            type="submit"
            style={{
              height: "60px",
              width: "300px",
              background: "#ff6600",
              border: "none",
            }}
            onClick={handleCompareClick}

          >
            <img
              src={CompareSvg}
              alt="Compare Icon"
              style={{ marginRight: "10px" }}
            />
            COMPARE ASSESSMENT
          </Button>

        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/new/Components/Reports/Assessment/AssessmentList/index.jsx